// LPPLWEBMOB-726
import { getConfig } from "./getConfig";

export const getModelsBasedOnMakeCode = async (
  makeCode: number
): Promise<ModelsData | undefined> => {
  const config = await getConfig();
  try {
    const response = await fetch(
      `${config.apiPostalCodesAndModelsEndpoint}models?makeCode=${makeCode}`
    ).then((r) => r.json());

    if (!response.length) {
      return;
    }

    const models = response.map((item: { Value: string }) => item.Value);

    const modelsSet = ([...new Set(models)] as unknown) as string[];

    const modelsOptions =
      modelsSet.length === 1 && (modelsSet[0] === "" || modelsSet[0] === null)
        ? []
        : modelsSet.map((item) => ({ value: item, label: item }));

    return {
      models: modelsOptions,
    };
  } catch {
    return undefined;
  }
};
export interface ModelsData {
  models: { label: string; value: string }[];
}
